/**
 * Classify onset/acquisition from a "signed day" metric:
 *   day >= 2     → HO-HA (test >48h post admission)
 *   0 <= day < 2 → HO-CA (test <48h post admission)
 *   day < 0:
 *      |day| <  28 → CO-HA (within 4 weeks of discharge)
 *      |day| <  84 → CO-HA (Indeterminate) (4–12 weeks)
 *      else        → CO-CA (no recent admissions within 12 weeks)
 *
 * Returns: { short, long, color }
 */

export function classifyBySignedDays(day, opts = {}) {
  const FOUR_WEEKS = opts.fourWeeks ?? 4 * 7;   // 28
  const TWELVE_WEEKS = opts.twelveWeeks ?? 12 * 7; // 84


  // Defensive: missing / non-number
  if (day === null || day === undefined || Number.isNaN(Number(day))) {
    day = -Math.infinity;
  }

  // Ensure number
  const d = Number(day);
  // const daysSinceDischarge = Math.abs(d);
  console.log('day', day)

  const onset = d >= 0 ? "HO" : "CO";

  let acquired = "";
  if (d >= 2) {
    acquired = "HA";
  } else if (d >= 0) {
    acquired = "CA";
  } else if (-d < FOUR_WEEKS) {
    acquired = "HA";
  } else if (-d < TWELVE_WEEKS) {
    acquired = "HA (Indeterminate)";
  } else {
    acquired = "CA";
  }

  const key = `${onset}|${acquired}`;

  switch (key) {
    case "HO|HA":
      return {
        short: "Likely HO-HA",
        long: "Hospital onset, likely hospital acquired (positive test >48h post admission OR <4 weeks post discharge from previous admission(s))",
        color: "#C0392B",
      };

    case "HO|HA (Indeterminate)":
      return {
        short: "Likely HO-HA (Indeterminate)",
        long: "Hospital onset, possibly hospital acquired from previous admission(s) (positive test <12 weeks post discharge)",
        color: "#C0392B",
      }; 

    case "HO|CA":
      // This occurs for inpatients tested <48h after admission and no recent discharge-based HA logic
      return {
        short: "Likely HO-CA",
        long: "Hospital onset, likely community acquired (positive test <48h post admission)",
        color: "#F39C12",
      };

    case "CO|HA":
      return {
        short: "Likely CO-HA",
        long: "Community onset, likely hospital acquired from previous admission(s) (positive test <4 weeks post discharge)",
        color: "#E74C3C",
      };

    case "CO|HA (Indeterminate)":
      return {
        short: "Likely CO-HA (Indeterminate)",
        long: "Community onset, possibly hospital acquired from previous admission(s) (positive test <12 weeks post discharge)",
        color: "#E74C3C",
      };

    case "CO|CA":
    default:
      return {
        short: "Likely CO-CA",
        long: "Community onset, likely community acquired (no recent admissions within 12 weeks)",
        color: "#F1C40F",
      };
  }
}